import styled from 'styled-components';
import { ReactComponent as SVG } from 'assets/error.svg';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100% - 40px);
  width: calc(100% - 40px);
  position: absolute;
`;

const Icon = styled(SVG)`
  width: 6rem;
  height: 6rem;
`;

const Title = styled.div`
  padding: 1rem 0;
  font-size: 3rem;
  font-family: "LFT Zeno Condensed";
`;

const Description = styled.div`
  color: #666666;
  padding-bottom: 1.5rem;
`;

export { Container, Title, Description, Icon };
